/* Carriely – productpagina extra's: voorraadvlag naast de kleur, 2e tas in een andere kleur, kortingscode kopiëren, verzendblok (NL/BE + gratis-verzending-teller), delen, reviews sorteren/filteren */
(() => {
  const money = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
  let data = null;
  try { data = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) {}

  const stock = document.querySelector('.pdp [data-stock]');
  const colorLabel = data && data.colorIndex >= 0 && document.querySelector(`.pdp .option[data-option-index="${data.colorIndex}"] .option__label`);
  if (stock && colorLabel) {
    const value = colorLabel.querySelector('[data-option-value]');
    if (value) value.after(stock); else colorLabel.appendChild(stock);
    const wrap = document.querySelector('.pdp__stock');
    if (wrap) wrap.classList.add('is-moved');
  }

  /* Bundel: bij "2 stuks" mag de 2e tas een andere kleur hebben. Dan gaan er twee varianten (elk 1x) in de winkelmand;
     de automatische korting op het 2e artikel geldt voor elke combinatie. */
  const bundle = document.querySelector('[data-bundle]');
  if (bundle && data && data.colorIndex >= 0 && (data.colors || []).length > 1) {
    const form = bundle.closest('form');
    const ci = data.colorIndex;
    const idInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[data-qty-input]');
    const duoInput = form.querySelector('[data-bundle-input][value="2"]');
    const duoNote = duoInput && duoInput.closest('label').querySelector('.bundle__text small');
    if (duoNote) duoNote.textContent += ' · ook in een andere kleur';
    const wrap = document.createElement('div');
    wrap.className = 'bundle-second';
    wrap.hidden = true;
    wrap.innerHTML = '<p class="bundle-second__label">Kleur van je 2e tas: <strong data-second-name></strong></p><div class="bundle-second__swatches" role="group" aria-label="Kleur van je 2e tas"></div>';
    bundle.after(wrap);
    const extra = document.createElement('div');
    extra.hidden = true;
    extra.innerHTML = '<input type="hidden" name="items[0][id]" disabled><input type="hidden" name="items[0][quantity]" value="1" disabled><input type="hidden" name="items[1][id]" disabled><input type="hidden" name="items[1][quantity]" value="1" disabled>';
    form.appendChild(extra);
    const itemInputs = Array.from(extra.querySelectorAll('input'));
    const labels = {};
    document.querySelectorAll(`.pdp .option[data-option-index="${ci}"] [data-option-input]`).forEach((i) => { labels[i.value] = i.dataset.label || i.value; });
    const current = () => data.variants.find((v) => v.id === Number(idInput.value));
    const match = (v, color) => data.variants.find((x) => x.options[ci] === color && x.options.every((o, k) => k === ci || o === v.options[k]));
    let secondColor = null;
    let second = null;
    const render = () => {
      const v = current();
      if (!v) return;
      if (secondColor === null) secondColor = v.options[ci];
      second = match(v, secondColor);
      if (!second || !second.available) { second = v; secondColor = v.options[ci]; }
      const box = wrap.querySelector('.bundle-second__swatches');
      box.innerHTML = '';
      data.colors.forEach((color) => {
        const m = match(v, color);
        if (!m) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bundle-second__swatch' + (m.image ? '' : ' bundle-second__swatch--text') + (m.available ? '' : ' is-unavailable');
        b.disabled = !m.available;
        b.title = labels[color] || color;
        b.setAttribute('aria-pressed', String(m.id === second.id));
        b.setAttribute('aria-label', `2e tas in ${labels[color] || color}`);
        b.innerHTML = m.image ? `<img src="${m.image}" alt="" width="56" height="56" loading="lazy">` : `<span>${labels[color] || color}</span>`;
        b.addEventListener('click', () => { secondColor = color; render(); sync(); });
        box.appendChild(b);
      });
      wrap.querySelector('[data-second-name]').textContent = labels[second.options[ci]] || second.options[ci];
    };
    const sync = () => {
      const duo = !!(duoInput && duoInput.checked);
      wrap.hidden = !duo;
      const v = current();
      const split = duo && v && second && second.id !== v.id;
      idInput.disabled = !!split;
      if (qtyInput) qtyInput.disabled = !!split;
      itemInputs.forEach((i) => { i.disabled = !split; });
      if (split) { itemInputs[0].value = v.id; itemInputs[2].value = second.id; }
    };
    form.addEventListener('change', () => setTimeout(() => { render(); sync(); }, 0));
    document.addEventListener('click', (e) => { if (e.target.closest('.pdp .option')) setTimeout(() => { render(); sync(); }, 60); });
    render();
    sync();
  }

  document.querySelectorAll('[data-copy]').forEach((btn) => {
    if (btn.closest('[data-popup]')) return;
    btn.addEventListener('click', async () => {
      const code = btn.dataset.copy;
      const label = btn.querySelector('[data-copy-label]');
      try {
        await navigator.clipboard.writeText(code);
      } catch (e) {
        const t = document.createElement('textarea');
        t.value = code;
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (_) {}
        t.remove();
      }
      if (label) {
        label.textContent = 'Gekopieerd';
        setTimeout(() => { label.textContent = 'Kopieer'; }, 2000);
      }
    });
  });

  const svc = document.querySelector('[data-svc]');
  if (svc) {
    svc.querySelectorAll('[data-svc-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        svc.querySelectorAll('[data-svc-tab]').forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on);
        });
        svc.querySelectorAll('[data-svc-cost]').forEach((p) => { p.hidden = p.dataset.svcCost !== tab.dataset.svcTab; });
      });
    });

    const threshold = Number(svc.dataset.threshold) || 0;
    const gap = svc.querySelector('[data-svc-gap]');
    const form = document.querySelector('[data-product-form]');
    let cartTotal = 0;

    const update = () => {
      if (!threshold || !gap || !form || !data) return;
      const idInput = form.querySelector('[name="id"]');
      const v = data.variants.find((x) => x.id === Number(idInput && idInput.value));
      if (!v) return;
      let item = v.price;
      const duo = form.querySelector('[data-bundle-input][value="2"]');
      if (duo && duo.checked) {
        const pct = Number(form.querySelector('[data-bundle]').dataset.pct) || 0;
        item = v.price + Math.round(v.price * (100 - pct) / 100);
      }
      if (cartTotal >= threshold) gap.textContent = 'Je bestelling wordt gratis verzonden';
      else if (cartTotal + item >= threshold) gap.textContent = 'Hiermee wordt je bestelling gratis verzonden';
      else gap.textContent = 'Nog ' + money(threshold - cartTotal - item) + ' tot gratis verzending';
      gap.hidden = false;
    };
    const loadCart = () => fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js')
      .then((r) => r.json())
      .then((c) => { cartTotal = c.total_price || 0; update(); })
      .catch(update);
    loadCart();
    document.addEventListener('change', () => setTimeout(update, 60));
    document.addEventListener('click', (e) => {
      if (e.target.closest('.info')) setTimeout(update, 120);
    });
    if (form) form.addEventListener('submit', () => setTimeout(loadCart, 1500));
  }

  document.querySelectorAll('[data-share]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const url = location.origin + location.pathname;
      if (navigator.share) {
        try { await navigator.share({ title: document.title, url }); } catch (e) {}
        return;
      }
      try { await navigator.clipboard.writeText(url); } catch (e) {}
      const label = btn.querySelector('[data-share-label]');
      if (label) {
        label.textContent = 'Link gekopieerd';
        setTimeout(() => { label.textContent = 'Delen'; }, 2000);
      }
    });
  });

  const rv = document.querySelector('[data-reviews]');
  if (rv) {
    const list = rv.querySelector('.reviews-list');
    const items = list ? Array.from(list.querySelectorAll('.review')) : [];
    const sort = rv.querySelector('[data-rv-sort]');
    const photos = rv.querySelector('[data-rv-photos]');
    const apply = () => {
      if (!list) return;
      const mode = sort ? sort.value : 'new';
      const only = photos && photos.getAttribute('aria-pressed') === 'true';
      const sorted = items.slice().sort((a, b) => {
        const ra = Number(a.dataset.rating), rb = Number(b.dataset.rating);
        const da = Number(a.dataset.date), db = Number(b.dataset.date);
        if (mode === 'high') return rb - ra || db - da;
        if (mode === 'low') return ra - rb || db - da;
        if (mode === 'photo') return Number(b.dataset.photo) - Number(a.dataset.photo) || db - da;
        return db - da;
      });
      sorted.forEach((el) => {
        el.hidden = only && el.dataset.photo !== '1';
        list.appendChild(el);
      });
    };
    if (sort) sort.addEventListener('change', apply);
    if (photos) photos.addEventListener('click', () => {
      photos.setAttribute('aria-pressed', photos.getAttribute('aria-pressed') !== 'true');
      apply();
    });
    rv.querySelectorAll('[data-rv-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        rv.querySelectorAll('[data-rv-tab]').forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on);
        });
        rv.querySelectorAll('[data-rv-panel]').forEach((p) => { p.hidden = p.dataset.rvPanel !== tab.dataset.rvTab; });
      });
    });
  }
})();
